import {
  useMediaQuery,
} from 'react-responsive';
import type {
  MediaQueryAllQueryable,
  MediaQueryMatchers,
} from 'react-responsive';

import {
  minTabletWidth,
  minDesktopWidth,
} from '@postcssVars';

export type PartialUseMediaQuery = (
  settings?: Partial<MediaQueryAllQueryable & { query?: string }>,
  device?: MediaQueryMatchers,
  callback?: (matches: boolean) => void
) => boolean;

export const useTabletOrWider: PartialUseMediaQuery = (
   
  settings = {},
  device,
  callback,
) => useMediaQuery(
  {
    ...settings,
    minWidth: minTabletWidth,
  },
  device,
  callback,
);

export const useDesktopOrWider: PartialUseMediaQuery = (
   
  settings = {},
  device,
  callback,
) => useMediaQuery(
  {
    ...settings,
    minWidth: minDesktopWidth,
  },
  device,
  callback,
);
